import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FeatherModule } from 'angular-feather';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { ValueComponent } from '~/v2/core/valuecomponent';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  imports: [FeatherModule, NgbTooltip, FormsModule, NgxMaskDirective, NgClass, TranslatePipe],
})
export class TextFieldComponent extends ValueComponent<any> implements OnChanges {
  @Input() title: string | null = null;
  @Input() showRemove = false;
  @Input() isReadOnly = false;
  @Input() hideLabel = false;
  @Input() disabled = false;
  @Input() readOnlyIfComplete = false;
  @Input() tooltip: string | null = null;
  @Input() readonlyTooltip: string | null = null;
  @Input() textMask: string | null = null;
  @Input() maxLength: number | null = null;
  @Output() clickRemoved = new EventEmitter<any>();

  showReadonlyView = false;
  initialValue: string | null = null;
  showReadonlyTooltip = false;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isReadOnly']) {
      return;
    }
    const valueIsChanged = changes['isReadOnly'].currentValue !== changes['isReadOnly'].previousValue;
    const valueWasUndefined = changes['isReadOnly'].previousValue === undefined;

    if (valueWasUndefined && changes['isReadOnly'].currentValue) {
      this.showReadonlyView = true;
      return;
    }

    if (!valueIsChanged) {
      return;
    }

    this.initialValue = JSON.parse(JSON.stringify(this.value));
    this.showReadonlyView =
      this.isReadOnly || (this.readOnlyIfComplete && this.value !== null && this.initialValue !== null);
  }

  isEmpty(): boolean {
    return this.value == undefined || this.value == null || this.value == '';
  }

  removeClicked(): void {
    this.clickRemoved.emit(this.value);
  }
}
